import request from 'utils/request'
// 获取表格数据
export const getTableData = data => request().post('relation/task/page', data)
/**
 * 获取企业列表
 * @param data
 * @returns {*}
 */
export const getCustomerList = data => request().get(`customer/list/${data}`)

// 获取母公司Id
export const getParentList = data => request().get(`customer/list/${data}`)

// 获取母公司账期
export const searchTerm = code => request().post(`customer/termList/${code}`)

// //客户详情查询
// export const customerDetail = id => request().get(`customer/query/${id}`)

/**
 * 获取审批人列表/credit/assurance/apply/approves/relation/approver/{type}
 */
export const getApprovePersons = type =>
  request().get(`relation/approver/${type}`)

// 集团关系申请
export const addGroup = data => request().post('relation/apply', data)

// queryBase/**
//  * 查询基本详情
// * @param {*} data
// */
export const queryBase = data => request().get(`bp/apply/queryBase/${data}`)

// 获取集团审批信息
export const getApplyList = bpmId =>
  request().get(`relation/approve/detail/${bpmId}`)
/**
 * 下载附件
 * @param {*} data assurance/download
 */
export const downloadAttachment = id => {
  return request().get(`relation/download/${id}`, {
    responseType: 'blob',
  })
}
// 审批
export const doApprove = data => request().post('relation/approve', data)
// 获取子公司账期信息
export const selectTemporaryRelationList = bpmId =>
  request().get(`temporary/term/list/${bpmId}`)
//账期信息
export const getCustomerOverviewSegment = id =>
  request().get(`customer/overview/segment/${id}`)

  // 获取标准账期
  export const getPeriodists = data => request().post('accountPeriod/periodLists', data)